import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * A custom element that allows the user to select a quantity.
 *
 * @typedef {Object} Refs
 * @property {HTMLInputElement} quantityInput
 *
 * @extends {Component<Refs>}
 */
class QuantitySelectorComponent extends Component {
  #onVariantChange = null;

  connectedCallback() {
    super.connectedCallback?.();

    // Bind once so we can remove it later
    this.#onVariantChange = (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (!t.matches('[data-variant-variant-input]')) return;

      // Optional: only respond if this quantity selector is on the same product section
      // (prevents issues if you have multiple products on the page)
      const sameSection =
        t.closest('[data-section-id]')?.dataset?.sectionId ===
        this.closest('[data-section-id]')?.dataset?.sectionId;

      if (!sameSection) return;

      this.#syncBuyNowHref();
    };

    document.addEventListener('change', this.#onVariantChange);

    // Optional: ensure link is correct on first load
    this.#syncBuyNowHref();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    if (this.#onVariantChange) {
      document.removeEventListener('change', this.#onVariantChange);
    }
  }

  /**
   * Handles the quantity increase event.
   * @param {Event} event - The event.
   */
  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    this.refs.quantityInput.stepUp();
    this.#onQuantityChange();
  }

  /**
   * Handles the quantity decrease event.
   * @param {Event} event - The event.
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    this.refs.quantityInput.stepDown();
    this.#onQuantityChange();
  }

  /**
   * When our input gets focused, we want to fully select the value.
   * @param {FocusEvent} event
   */
  selectInputValue(event) {
    const { quantityInput } = this.refs;
    if (!(event.target instanceof HTMLInputElement) || document.activeElement !== quantityInput) return;

    quantityInput.select();
  }

  /**
   * Handles the quantity set event.
   * @param {Event} event - The event.
   */
  setQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    if (event.target instanceof HTMLInputElement) {
      this.refs.quantityInput.value = event.target.value;
    }
    this.#onQuantityChange();
  }

  /**
   * Handles the quantity change event.
   */
  #onQuantityChange() {
    const { quantityInput } = this.refs;

    this.#checkQuantityRules();

    const newValue = parseInt(quantityInput.value, 10);

    // keep buy now link synced
    this.#syncBuyNowHref();

    quantityInput.dispatchEvent(
      new QuantitySelectorUpdateEvent(newValue, Number(quantityInput.dataset.cartLine))
    );
  }

  /**
   * Syncs the Buy Now button URL to /cart/{variantId}:{qty} while preserving query params.
   */
  #syncBuyNowHref() {

    // Add-on quantity selectors must NOT rewrite the main product's Buy Now /
    // checkout-button hrefs. They live inside [data-addon-qty-wrap] and have their own
    // checkout wiring (product-addon.liquid / addon-checkout-link.liquid read the add-on
    // qty at click time). Without this guard, changing an add-on qty stamps that value
    // onto the main product's checkout URL.
    if (this.closest('[data-addon-qty-wrap]')) return;

    // Cart-line quantity selectors must NOT rewrite the product page's Buy Now /
    // checkout hrefs either. The cart drawer is rendered from the header on EVERY
    // page, so its line-item selectors mount on every PDP and — because the writes
    // below are document-wide — a cart line of 2 (from any product) was stamping
    // ":2" onto the current PDP's Buy Now permalink. Cart lines are rendered by
    // quantity-selector.liquid with line_index set, which is the only case that
    // produces name="updates[]" + data-cart-line.
    if (this.#isCartLineSelector()) return;

    // Current variant id (from your variant picker)

    // Current qty. Only ever read THIS component's own input — falling back to a
    // document-wide lookup can pick up an unrelated product's quantity.
    const qtyInput = this.refs?.quantityInput || this.querySelector?.('input[name="quantity"]');





    const qty = Math.max(1, parseInt(qtyInput?.value ?? '1', 10) || 1);

              const checkedVariant =
      // if the variant picker is inside this component, prefer that
      this.querySelector?.('[data-variant-variant-input]:checked') ||
      // otherwise fall back to the page
      document.querySelector('[data-variant-variant-input]:checked');

    const variantId = checkedVariant?.dataset?.variantId || checkedVariant?.value;
    if (variantId) {



    // Optional: scope to this section if you have multiple product sections
    const root = this.closest('[data-section-id]') || document;

    // Find the buy-container for THIS variant (supports both patterns)
    const buyContainer = document.querySelector(`div[data-buy-variant-id="${variantId}"]`);
  
    if (!buyContainer) return;

  
    // Link inside that container
    const buyNowLink = buyContainer.querySelector('a[data-buy-now-button="true"]');
    if (!buyNowLink) return;
    
  

    // Base = the server-computed checkout URL on the container (preserves the
    // main_variant mapping + discount). Only swap the quantity in the path; do NOT
    // rebuild it from the storefront variant id, which would drop the main_variant
    // mapping and add the CURRENT product to the cart instead of the mapped variant.
    const baseHref = buyContainer.dataset.checkoutUrl || buyNowLink.href;
    const newUrl = new URL(baseHref, window.location.origin);
    newUrl.pathname = newUrl.pathname.replace(/:\d+$/, `:${qty}`);

    buyNowLink.href = newUrl.toString();

      // ---------- 4) Update abar link ----------
    const abarLink =
      this.querySelector?.('.extra_abar a') || document.querySelector('.extra_abar a');

    if (abarLink) {
      
        abarLink.setAttribute('href', newUrl.toString());
      
    }

      // 2) Update "Add to cart" inline price text (.show_price_btn)
      const checkoutButtons = document.querySelectorAll(
        'a.checkout-button'
      );

        checkoutButtons.forEach((buyButton) => {
          buyButton.href = newUrl.toString();
      });

}else {
   var variantInput =
          this.querySelector?.('input[ref="variantId"]') ||
      document.querySelector('input[ref="variantId"]');
if(!variantInput) return;
const variantId = variantInput.value;

  // Prefer the server-computed checkout URL (preserves main_variant + discount);
  // only fall back to a bare cart permalink if no container is present.
  const elseContainer = document.querySelector(`div[data-buy-variant-id="${variantId}"]`);
  var newUrl;
  if (elseContainer?.dataset?.checkoutUrl) {
    newUrl = new URL(elseContainer.dataset.checkoutUrl, window.location.origin);
    newUrl.pathname = newUrl.pathname.replace(/:\d+$/, `:${qty}`);
  } else {
    newUrl = new URL(`/cart/${variantId}:${qty}?channel=buy_button`, window.location.origin);
  }

      // ---------- 4) Update abar link ----------
    const abarLink =
      this.querySelector?.('.extra_abar a') || document.querySelector('.extra_abar a');

    if (abarLink) {

  abarLink.setAttribute('href', newUrl.toString());

    }

      // 2) Update "Add to cart" inline price text (.show_price_btn)
      const checkoutButtons = document.querySelectorAll(
        'a.checkout-button'
      );

        checkoutButtons.forEach((buyButton) => {
         buyButton.href = newUrl.toString();
      });

      // Update buy-button-variant link for this variant
      const buyNowLink = /** @type {HTMLAnchorElement|null} */ (document.querySelector(`div[data-buy-variant-id="${variantId}"] a[data-buy-now-button="true"]`));
      if (buyNowLink) { buyNowLink.href = newUrl; }


}

  }

  /**
   * Whether this selector controls a cart line (cart drawer / cart page) rather
   * than the quantity for a product form on the page.
   * @returns {boolean}
   */
  #isCartLineSelector() {
    const input = this.refs?.quantityInput;
    if (input?.name === 'updates[]' || input?.dataset?.cartLine != null) return true;

    return Boolean(this.closest('cart-items-component, .cart-items, .cart-items__wrapper'));
  }

  /**
   * Checks the quantity rules are met
   */
  #checkQuantityRules() {
    const { quantityInput } = this.refs;
    const { min, max, value: newValue } = quantityInput;

    if (min && Number(newValue) < Number(min)) quantityInput.value = min;
    if (max && Number(newValue) > Number(max)) quantityInput.value = max;
  }

  /**
   * Gets the quantity input.
   * @returns {HTMLInputElement} The quantity input.
   */
  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error('Missing <input ref="quantityInput" /> inside <quantity-selector-component />');
    }

    return this.refs.quantityInput;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}